var AbstractMatcher = /** @class */ (function () {
    function AbstractMatcher(expr, pm) {
        this.pm = pm;
        this._matcher = expr.replace(/^m ?= ?/, '');
    }
    return AbstractMatcher;
}());
export { AbstractMatcher };
